import React, { ReactNode } from "react";
import { Outlet } from "react-router-dom";

import { Sidebar } from "./Sidebar";
import { Navbar } from "./Navbar";

interface DashboardLayoutProps {
  children?: ReactNode;
}

const AccountLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  return (
    <div className="account-layout">
      <Sidebar />
      <div className="account-content">
        <Navbar />
        <div className="account-content-inner">{children || <Outlet />}</div>
      </div>
    </div>
  );
};

export default AccountLayout;
